import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'fa',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class IconComponent implements OnInit {

  @Input() name: string = '';

  constructor() {}

  ngOnInit(): void {
  }

}
